import { Box, Grid, GridItem, Heading } from '@chakra-ui/layout';
import React from 'react';

type SectionProps = {
  title: string;
  values: {}[];
};

export const PreviewSection = ({
  title,
  values,
}: SectionProps): JSX.Element => {
  return (
    <Box as="div">
      <Heading size="md" mb={5}>
        {title}
      </Heading>
      <Grid templateColumns="repeat(3, 1fr)" gap={4}>
        {values.map((val, index) => (
          <React.Fragment key={index}>
            {Object.entries(val).map(([label, value]) =>
              value ? (
                <React.Fragment key={label}>
                  <GridItem colSpan={1} fontWeight={600} color="gray.400">
                    {label}
                  </GridItem>
                  <GridItem colStart={2} colEnd={6}>
                    {value as string}
                  </GridItem>
                </React.Fragment>
              ) : null
            )}
          </React.Fragment>
        ))}
      </Grid>
    </Box>
  );
};
